import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../../styles/styles.css';

const Header = () => {
  const [isMobileNavActive, setIsMobileNavActive] = useState(false);
  const [headerScrolled, setHeaderScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setHeaderScrolled(true);
      } else {
        setHeaderScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Add/remove class from body when mobile nav state changes
  useEffect(() => {
    if (isMobileNavActive) {
      document.body.classList.add('mobile-nav-active');
    } else {
      document.body.classList.remove('mobile-nav-active');
    }
  }, [isMobileNavActive]);

  const toggleMobileNav = () => {
    setIsMobileNavActive(!isMobileNavActive);
  };

  const closeMobileNav = () => {
    setIsMobileNavActive(false);
  };

  return (
    <>
      <header id="header" className={headerScrolled ? 'header-scrolled' : ''}>
        <div className="container-fluid">
          <div id="logo" className="pull-left">
            <h1>
              <Link 
                to="/" 
                className="scrollto" 
                style={{ 
                  textDecoration: 'none', 
                  display: 'block'
                }}
              >
                {/* Container for the entire logo */}
                <div style={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  
                  {/* Logo text - Remove all whitespace between spans */}
                  <div style={{ 
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'baseline',
                    width: 'auto',
                    position: 'relative',
                    margin: '0 auto'
                  }}>
                    <span className="logo-text" style={{ 
                      color: '#00e7ff', // Blue color for VIN
                      fontSize: '32px',
                      fontWeight: 'bold',
                      lineHeight: '1',
                      fontFamily: '"Montserrat", sans-serif'
                    }}>VIN</span>
                    <span className="logo-text" style={{ 
                      color: '#a8a9a9', // Light black/gray for F
                      fontSize: '32px',
                      fontWeight: 'bold',
                      lineHeight: '1',
                      fontFamily: '"Montserrat", sans-serif'
                    }}>F</span>
                    <span className="logo-text" style={{ 
                      color: '#a8a9a9', // Light black/gray for O
                      fontSize: '32px',
                      fontWeight: 'bold',
                      lineHeight: '1',
                      fontFamily: '"Montserrat", sans-serif'
                    }}>O</span>
                    <span className="logo-text" style={{ 
                      color: '#00e7ff', // Blue color for CLOUD
                      fontSize: '32px',
                      fontWeight: 'bold',
                      lineHeight: '1',
                      fontFamily: '"Montserrat", sans-serif'
                    }}>CLOUD</span>
                  </div>
                  
                  {/* Tag line - This will be perfectly centered */}
                  <div style={{ 
                    width: '100%',
                    textAlign: 'center',
                    marginTop: '2px'
                  }}>
                    <span className="tagline-span" style={{ 
                      color: '#00e7ff', // Blue color for tagline
                      fontSize: '9px',
                      letterSpacing: '2px',
                      fontWeight: 'normal',
                      lineHeight: '1',
                      fontFamily: '"Montserrat", sans-serif'
                    }}>
                      IT SOLUTIONS and STAFFING
                    </span>
                  </div>
                </div>
              </Link>
            </h1>
          </div>

          <nav id="nav-menu-container">
            <ul className="nav-menu">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </nav>

          <div id="mobile-nav-toggle" onClick={toggleMobileNav}>
            <i className="fa fa-bars"></i>
          </div>
        </div>
      </header>

      {/* Remove the className from here */}
      <div id="mobile-nav">
        <ul>
          <li><Link to="/" onClick={closeMobileNav}>Home</Link></li>
          <li><Link to="/about" onClick={closeMobileNav}>About Us</Link></li>
          <li><Link to="/services" onClick={closeMobileNav}>Services</Link></li>
          <li><Link to="/contact" onClick={closeMobileNav}>Contact</Link></li>
        </ul>
      </div>

      <div 
        id="mobile-body-overly" 
        onClick={closeMobileNav}
        style={{ display: isMobileNavActive ? 'block' : 'none' }}
      ></div>
    </>
  );
};

export default Header;